module.exports = __webpack_public_path__ + "assets/icons-manage-fleet-24-px.fc98fd9e.svg";